// extracted by mini-css-extract-plugin
export default {"modal":"ModalForm_modal__8lB7m","mask":"ModalForm_mask__iuvf8","close":"ModalForm_close__XebdS","form":"ModalForm_form__m4WwQ"};